module.exports = __webpack_public_path__ + "img/ee2.a059396c.jpg";